<template>
  <div class="sidebar-position-detail-index">
    <div
      class="sidebar-position-detail-index__top"
      :style="{
        'background-color': this.activePosition.gemeente.app_asset
          ? this.activePosition.gemeente.app_asset.color_primary
          : null
      }"
    >
      <div class="sidebar-position-detail-index__top__left">
        <svg svg-inline="" @click="closeSidebarPositionIndex" class="sidebar-position-detail-index__top__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        <div class="sidebar-position-detail-index__top__left__text">
          {{ activePosition.address }}
        </div>
      </div>
      <div class="sidebar-position-detail-index__top__right">
        <svg svg-inline="" @click="openSidebarPositionDetailMapView" class="sidebar-position-detail-index__top__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 11-4 0z" fill="#101010" mask="url(#b)"/><path d="M6.49 14a31.12 31.12 0 001.109 1.855H6.204l-1.086 5.214 14.1-.084-1.124-5.13H16.67c.386-.6.761-1.222 1.11-1.855h1.742l2.516 8.994L2 22.93 4.47 14h2.02z" fill="#101010" mask="url(#b)"/></g></svg>
      </div>
    </div>

    <div class="sidebar-position-detail-index__scrollable">
      <template v-if="deletedFeaturesLength > 0 || starredFeaturesLength > 0">
        <div class="sidebar-position-detail-index__top-nav">
          <template v-if="deletedFeaturesLength > 0">
            <SidebarListItem
              :bordered="true"
              :centered="true"
              @click.native="openSidebarPositionDetailIndexDeleted"
            >
              <div class="sidebar-list-item__left">
                <svg svg-inline="" class="sidebar-list-item__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#101010" mask="url(#b)"/></g></svg>
              </div>
              <div class="sidebar-list-item__middle">
                <div class="sidebar-list-item__middle__text">
                  {{ deletedFeaturesLength }} verwijderde
                  {{ pluralMeldingen(deletedFeaturesLength) }}
                </div>
              </div>
              <div class="sidebar-list-item__right">
                <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
              </div>
            </SidebarListItem>
          </template>
          <template v-if="starredFeaturesLength > 0">
            <SidebarListItem
              :bordered="true"
              :centered="true"
              @click.native="openSidebarPositionDetailIndexStarred"
            >
              <div class="sidebar-list-item__left">
                <svg svg-inline="" class="sidebar-list-item__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#FFCD00" mask="url(#b)" d="M11.868 17.07l6.1 3.68-1.62-6.938 5.389-4.667-7.096-.602L11.868 2 9.095 8.543 2 9.145l5.388 4.668L5.77 20.75z"/></g></svg>
              </div>
              <div class="sidebar-list-item__middle">
                <div class="sidebar-list-item__left__text">
                  {{ starredFeaturesLength }} belangrijke
                  {{ pluralMeldingen(starredFeaturesLength) }}
                </div>
              </div>
              <div class="sidebar-list-item__right">
                <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
              </div>
            </SidebarListItem>
          </template>
        </div>
      </template>

      <template v-if="polygonFeaturesLength > 0">
        <div class="sidebar-position-detail-index__scrollable__titlebar">
          <div
            class="sidebar-position-detail-index__scrollable__titlebar__title"
          >
            <div
              class="sidebar-position-detail-index__scrollable__titlebar__left"
            >
              Gebiedsmeldingen
            </div>
          </div>
        </div>

        <SidebarListItem
          @click.native="openSidebarPositionDetailIndexPolygon"
          :gebiedsmeldingicon="true"
        >
          <div class="sidebar-list-item__left">
            <div
              class="sidebar-list-item__left__icon-container"
              :style="{
                'background-color': activePosition.gemeente.app_asset
                  ? activePosition.gemeente.app_asset.color_primary
                  : null
              }"
            >
              <img
                svg-inline
                src="../../assets/ic/icons/ic_notifications_nb.png"
                class="sidebar-list-item__left__icon-container__icon"
              />
            </div>
          </div>
          <div class="sidebar-list-item__middle">
            <div class="sidebar-list-item__middle__text-title">
              Gebiedsmeldingen
            </div>
            <div
              class="sidebar-list-item__middle__text-subtitle bigger-subtitle"
            >
              In totaal {{ polygonFeaturesLength }}
              {{ polygonFeaturesLength == 1 ? "melding" : "meldingen" }} die
              geen specifieke locatie
              {{ polygonFeaturesLength == 1 ? "heeft" : "hebben" }} maar wel in
              de omgeving van je locatie
              {{ polygonFeaturesLength == 1 ? "ligt" : "liggen" }}
            </div>
          </div>
          <div class="sidebar-list-item__right">
            <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
          </div>
        </SidebarListItem>
      </template>

      <div class="sidebar-position-detail-index__scrollable__titlebar">
        <div class="sidebar-position-detail-index__scrollable__titlebar__left">
          <div
            class="sidebar-position-detail-index__scrollable__titlebar__title"
          >
            Meldingen met locatie
          </div>
        </div>
        <div class="sidebar-position-detail-index__scrollable__titlebar__right">
          <div
            class="sidebar-position-detail-index__scrollable__titlebar__buttons"
          >
            <button
              @click="sortByDistance"
              :class="{
                'sidebar-position-detail-index__scrollable__titlebar__buttons__button': true,
                active: sortDistance
              }"
              :style="{
                color:
                  this.activePosition.gemeente.app_asset && sortDistance
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
              }"
            >
              Afstand
            </button>
            <button
              @click="sortByDateAsc"
              :class="{
                'sidebar-position-detail-index__scrollable__titlebar__buttons__button': true,
                active: sortDate
              }"
              :style="{
                color:
                  this.activePosition.gemeente.app_asset && sortDate
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
              }"
            >
              Datum
            </button>
          </div>
        </div>
      </div>

      <div class="sidebar-position-detail-index__scrollable__list-bottom">
        <SidebarListItem
          v-for="feature in pointFeatures"
          :key="feature.id"
          @click.native="setActiveFeature(feature)"
          :active="
            activeFeature
              ? activeFeature.properties.id == feature.properties.id
              : false
          "
        >
          <div class="sidebar-list-item__left">
            <img
              :src="
                getCategory(feature.properties.category_id)
                  ? getCategory(feature.properties.category_id).icon_url
                  : ''
              "
              class="sidebar-list-item__left__icon"
            />
          </div>
          <div class="sidebar-list-item__middle">
            <div
              :class="{
                'sidebar-list-item__middle__text-title': true,
                read: isRead(feature.properties.id)
              }"
            >
              {{ feature.properties.name }}
            </div>
            <div class="sidebar-list-item__middle__text-subtitle">
              {{ $dayjs(feature.properties.published_at).format("LL") }} -
              {{ getCategoryName(feature.properties.category_id) }}
            </div>
            <div class="sidebar-list-item__middle__text-subtitle">
              {{ feature.properties.distance }}m
            </div>
          </div>
          <div class="sidebar-list-item__right">
            <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
          </div>
        </SidebarListItem>
      </div>
    </div>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories.js";
import SidebarListItem from "@/components/SidebarListItem";
import CategoryIdToString from "@/services/CategoryIdToString";

export default {
  components: {
    SidebarListItem
  },
  data() {
    return {
      // pointFeatures: null,
      // polygonFeaturesLength: 0,
      loadedCategories: null,
      sortDate: true,
      sortDistance: false
    };
  },
  mounted() {
    let self = this;

    LoadOrReturnCategories().then(function(categories) {
      self.loadedCategories = categories;
    });

    if (this.activePosition) {
      PrivateApi()
        .get(`positions/${this.activePosition.id}/features`)
        .then(function(features) {
          var pointFeatures = features.data.features.filter(
            x => x.geometry.type == "Point"
          );
          let polygonFeatures = features.data.features.filter(
            x => x.geometry.type == "Polygon"
          );
          var deletedFeaturesIds = self.deletedFeatures.map(
            x => x.properties.id
          );
          var starredFeaturesIds = self.starredFeatures.map(
            x => x.properties.id
          );
          pointFeatures = pointFeatures.filter(
            x =>
              !deletedFeaturesIds.includes(x.properties.id) &&
              !starredFeaturesIds.includes(x.properties.id)
          );
          polygonFeatures = polygonFeatures.filter(
            x => !deletedFeaturesIds.includes(x.properties.id)
          );
          self.$store.commit("setPointFeatures", pointFeatures);
          self.$store.commit("setPolygonFeatures", polygonFeatures);

          var unreadFeatures = features.data.features.filter(
            x => x.properties.unread == true
          ).length;

          if (unreadFeatures > 0) {
            let params = {
              mark_as_read: true
            };

            PrivateApi().put(`positions/${self.activePosition.id}`, params);
          }
        });
    }
  },
  computed: {
    activePosition() {
      return this.$store.state.ui.activePosition;
    },
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    starredFeatures() {
      return this.$store.state.ui.starredFeatures;
    },
    deletedFeatures() {
      return this.$store.state.ui.deletedFeatures;
    },
    starredFeaturesLength() {
      return this.starredFeatures ? this.starredFeatures.length : 0;
    },
    deletedFeaturesLength() {
      return this.deletedFeatures ? this.deletedFeatures.length : 0;
    },
    pointFeatures() {
      return this.$store.state.ui.pointFeatures;
    },
    polygonFeatures() {
      return this.$store.state.ui.polygonFeatures;
    },
    readFeatures() {
      return this.$store.state.ui.readFeatures;
    },
    polygonFeaturesLength() {
      return this.polygonFeatures.length;
    }
  },
  methods: {
    getCategoryName(category_id) {
      let string = CategoryIdToString(category_id);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeSidebarPositionIndex() {
      this.$store.commit("setActiveFeature", null);
      this.$store.commit("closeLayoutPosition");
      this.$store.commit("openLayoutHome");
      if (this.$route.matched.filter(x => x.path == "/positions/:id").length) {
        this.$router.push("/");
      }
    },
    openSidebarPositionDetailMapView() {
      this.$store.commit("closeSidebarPositionDetailIndex");
      this.$store.commit("openSidebarPositionDetailMapView");
    },
    openSidebarPositionDetailIndexDeleted() {
      // this.$store.commit("setActiveFeature", this.deletedFeatures[0]);
      // this.$store.commit("setReadFeatures", this.deletedFeatures[0]);
      this.$store.commit("closeSidebarPositionDetailIndex");
      this.$store.commit("openSidebarPositionDetailIndexDeleted");
    },
    openSidebarPositionDetailIndexStarred() {
      // this.$store.commit("setActiveFeature", this.starredFeatures[0]);
      // this.$store.commit("setReadFeatures", this.starredFeatures[0]);
      this.$store.commit("closeSidebarPositionDetailIndex");
      this.$store.commit("openSidebarPositionDetailIndexStarred");
    },
    openSidebarPositionDetailIndexPolygon() {
      // this.$store.commit("setActiveFeature", this.polygonFeatures[0]);
      // this.$store.commit("setReadFeatures", this.polygonFeatures[0]);
      this.$store.commit("closeSidebarPositionDetailIndex");
      this.$store.commit("openSidebarPositionDetailIndexPolygon");
    },
    setActiveFeature(feature) {
      this.$store.commit("setActiveFeature", feature);
      this.$store.commit("setReadFeatures", feature);
    },
    getCategory(categoryId) {
      if (this.loadedCategories) {
        return this.loadedCategories.data.find(x => x.id == categoryId);
      }
    },
    sortByDateAsc() {
      var pointFeatures = this.pointFeatures.sort(
        (a, b) =>
          new Date(b.properties.published_at).getTime() -
          new Date(a.properties.published_at).getTime()
      );
      this.$store.commit("setPointFeatures", pointFeatures);
      this.sortDate = true;
      this.sortDistance = false;
    },
    sortByDistance() {
      var pointFeatures = this.pointFeatures.sort(
        (a, b) => a.properties.distance - b.properties.distance
      );
      this.$store.commit("setPointFeatures", pointFeatures);
      this.sortDate = false;
      this.sortDistance = true;
    },
    pluralMeldingen(length) {
      return length == 1 ? "melding" : "meldingen";
    },
    isRead(featureId) {
      return this.readFeatures.includes(featureId);
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-detail-index {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  box-shadow: 2px 4px 10px 0 rgba(0, 0, 0, 0.05);

  &__top-nav {
    width: 100%;
  }

  &__top {
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
    background: $color-green-1;

    &__left {
      display: flex;
      align-items: center;
      width: calc(100% - 52px);

      &__icon {
        display: inline-block;
        position: relative;
        top: 1px;
        width: 36px;
        height: 36px;
        cursor: pointer;
        left: -8px;

        path {
          fill: #fff;
        }
      }
      &__text {
        display: inline-block;
        @extend %text-large;
        color: #fff;
        padding: 0 $spacing-2 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__right {
      margin-left: auto;
      margin-right: $spacing-3;

      &__icon {
        cursor: pointer;
        background-size: 24px 24px;
        width: 24px;
        height: 24px;
        border: 0;

        path {
          fill: #fff;
        }
      }
    }
  }

  &__scrollable {
    display: flex;
    flex: 1;
    overflow-y: auto;
    height: calc(100% - 52px);
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;

    &__titlebar {
      display: flex;
      align-items: center;
      height: 48px;
      width: 100%;

      &__left {
        padding-left: $spacing-3;
      }

      &__title {
        @extend %text-small;
      }

      &__right {
        margin-left: auto;
        padding-right: $spacing-3;
      }

      &__buttons {
        display: flex;

        &__button {
          height: 30px;
          text-align: center;
          padding: 0 $spacing-2;
          line-height: 30px;
          @extend %text-mini;
          outline: 0;
          background: $color-gray-1;
          color: $color-black-3;
          border: 1px solid transparent;

          &.active {
            background: $color-gray-2;
            color: $color-green-1;
            border: 1px solid $color-gray-1;
          }
          &:first-child {
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          }
          &:last-child {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }
        }
      }
    }

    &__list-bottom {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
}
</style>
